import React, { Component } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';

import api from '../../../../lib/api';

type Props = {
  value: string,
  handleBlur: string,
  setFormikState: () => void,
};
export default class NationalityDropdown extends Component<Props> {
  state = {
    countries: [],
  };

  async componentDidMount() {
    const { data } = await api.get('places/countries');

    this.setState({ countries: data });
  }

  handleSelected = selected => {
    const { setFormikState } = this.props;

    if (selected.length !== 0) {
      setFormikState(selected[0].iso_alpha_2);
    } else {
      setFormikState('');
    }
  };

  render() {
    const { countries } = this.state;

    const { value, handleBlur } = this.props;

    return (
      <Typeahead
        placeholder="Select Nationality"
        onChange={this.handleSelected}
        options={countries}
        labelKey="name"
        onBlur={handleBlur}
        selected={countries.filter(country => country.iso_alpha_2 === value)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/CustomerDetails/NationalityDropdown.js